import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const getEmailLetterTemplates = (params: any, moduleName?: string) => {
  return axios({
    method: "GET",
    url: "/templates",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-module-name": moduleName,
    },
  });
};

export const getFoldersList = (params: any) => {
  return axios({
    method: "GET",
    url: "/templates/folder",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createNewFolder = (data: any) => {
  return axios({
    method: "POST",
    url: "/templates/folder",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const moveTemplateToFolder = (data: any) => {
  return axios({
    method: "PUT",
    url: "/templates/bulk-move",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteSingleTemplate = (id: number, params: any) => {
  return axios({
    method: "DELETE",
    url: `/templates/${id}`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteBulkTemplates = (data: any, params: any) => {
  return axios({
    method: "DELETE",
    url: "/templates/bulk-delete",
    data,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const parseImportedTemplateFile = (data: any) => {
  return axios({
    method: "POST",
    url: "/templates/import/parse",
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const importTemplates = (data: any) => {
  return axios({
    method: "PUT",
    url: "/templates/import/finalize",
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const exportTemplates = (data: any, params: any) => {
  return axios({
    method: "POST",
    url: `/templates/export`,
    data: data,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTemplateHeaderOrFooter = (key?: string) => {
  return axios({
    method: "GET",
    url: `/templates/meta`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editTemplateHeaderOrFooter = (key: string, data: any) => {
  return axios({
    method: "PUT",
    url: `/templates/meta/${key}`,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createNewEmailTemplate = (data: any) => {
  const isFormData = data instanceof FormData;
  
  return axios({
    method: "POST",
    url: "/templates",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(isFormData && {
        'Content-Type': 'multipart/form-data',
      }),
    },
  });
};

export const editEmailTemplates = (id: number, data: any) => {
  const isFormData = data instanceof FormData;
  
  return axios({
    method: "PUT",
    url: `/templates/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(isFormData && {
        'Content-Type': 'multipart/form-data',
      }),
    },
  });
};

export const getEmailTemplateDetails = (
  id: string,
  params:any,
) => {
  return axios({
    method: "GET",
    url: `templates/${id}`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getUnsubscribedUsersList = (params: any) => {
  return axios({
    method: "GET",
    url: "/templates/opt-out-list",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
